export default "__VITE_ASSET__BQIzo3Ux__"